export enum Language {
  en = 'en',
  fr = 'fr',
}
